import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";

@Component({
    selector: 'app-news',
    templateUrl: './news.component.html',
    styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {
    selectedSection: string = 'section1';
    pageTitle: string;
    activeIndex: number | null = null;
    selectedImage: { src: string; date: Date } | null = null;
    currentRoute: string = '';
    openedIndex: number | null = null;
    selectedEvent: any = null;

    announcements = [
        {
            date: '11 Sept 2025',
            title: 'Announcing ICIT 2025, in Collaboration with ARNI University and INTI University – 11 Sept at INTI',
            color: '#EF4444',
            description: 'To know more about this event click on the link below:',
            downloadLabel: 'https://icit2025.newinti.edu.my/',
            downloadUrl: 'https://icit2025.newinti.edu.my/',
            openExternally: true
        },
        {
            date: '13 May 2025',
            title: 'We Are Hiring!',
            color: '#22C55E',
            description: 'Join Our Growing Team at Arni University',
            downloadLabel: 'Download Brochure',
            downloadUrl: 'assets/img/announcements/pdfs/we-are-hiring-announcement.pdf',
            openExternally: false
        },
        {
            date: '02 Apr 2025',
            title: 'Admissions To PhD Programme',
            color: '#EC4899',
            description: 'Explore PhD admissions for the academic year 2025.',
            downloadLabel: 'Download Brochure',
            downloadUrl: 'assets/img/announcements/pdfs/phd-admissions.pdf',
            openExternally: false
        },
        {
            date: '02 Apr 2025',
            title: 'Admissions To PhD Programme',
            color: '#F59E0B',
            description: 'Explore PhD admissions for the academic year 2025.',
            downloadLabel: 'Download Brochure',
            downloadUrl: 'assets/img/announcements/pdfs/phd-admissions.pdf',
            openExternally: false
        },
        {
            date: '02 Apr 2025',
            title: 'Scholarship Upto 100%',
            color: '#22C55E',
            description: 'Grab the opportunity to avail up to 100% scholarship based on merit.',
            downloadLabel: 'Download Details',
            downloadUrl: 'assets/img/announcements/pdfs/scholarship.pdf',
            openExternally: false
        },
        {
            date: '02 Apr 2025',
            title: 'Programs Offered',
            color: '#EC4899',
            description: 'Discover a variety of undergraduate and postgraduate programs.',
            downloadLabel: 'Download List',
            downloadUrl: 'assets/img/announcements/pdfs/programs-offered.pdf',
            openExternally: false
        },
        {
            title: 'Convocation Registration 2025',
            description: 'All final-year students are requested to complete the convocation registration process by visiting the Arni University portal. The last date to register is May 15, 2025.',
            date: new Date('2025-03-01'),
            color: '#EF4444',
            openExternally: false
        },
        {
            title: 'Alumni Meet Registration',
            description: 'Arni University is organizing its Annual Alumni Meet on June 10, 2025. Alumni are requested to register online through the official alumni portal before May 25.',
            date: new Date('2025-02-20'),
            color: '#EC4899',
            openExternally: false
        },
        {
            title: 'International Conference',
            description: 'The School of Engineering & Technology at Arni University is hosting an International Conference on AI and Robotics from July 15–17. Submit your research papers by May 30.',
            date: new Date('2025-02-17'),
            color: '#10B981',
            openExternally: false
        },
        {
            title: 'Course Approval (2024–25)',
            description: 'Faculty members must submit their proposed course structures and syllabi for the academic session 2024–25 by April 25 via the ERP system. Ensure compliance with UGC guidelines.',
            downloadLabel: 'Download',
            downloadUrl: 'assets/img/announcements/pdfs/course-approval.pdf',
            date: new Date('2025-02-13'),
            color: '#F59E0B',
            openExternally: false
        },
        {
            title: 'Admission Helpline No- 1800-891-8962, 90-1590-9622',
            description: 'Admission Helpline Numbers',
            date: new Date('2025-02-07'),
            color: '#EF4444',
            openExternally: false
        }
    ];

    pdfUrl: string | null = null;
    sanitizedPdfUrl: SafeResourceUrl | null = null;
    showPdfModal = false;
    events = [
        {
            image: 'assets/img/miss-himachal-2025/miss-himachal-event-2025-1.jpg',
            date: '17 April 2025',
            title: 'Miss Himachal 2025',
            description: 'A grand celebration of the beauty, talent, and spirit of the hills! Held on 17th April, Miss Himachal 2025 is proudly supported by ARNI University and costume by its Fashion Designing Department.'
        },
        {
            date: '15 Sept 2023',
            title: 'National Conference',
            description: 'ARNI University proudly received recognition for its outstanding contribution to the educational sector, highlighting its dedication to academic excellence, innovation, and shaping future leaders.',
            image: 'assets/img/whats-happeing-inarni-home-page/whats-happening3.webp'
        },
        {
            date: '18 Oct 2022',
            title: 'Convocation Day 2022',
            description: 'A grand celebration of achievements, cherished memories, and new beginnings\n' +
                '                        — presenting the highlights from ARNI University\'s Convocation held on October 18, 2022.',
            image: 'assets/img/whats-happeing-inarni-home-page/whats-happening2.webp'
        },
        {
            date: '15 Sept 2023',
            title: 'Jagran Achiever Awards',
            description: 'At the Jagran Achiever Awards 2022, ARNI University was honored with the prestigious title of \'Fast Rising & Emerging University in North India,\' recognizing our commitment to excellence.',
            image: 'assets/img/whats-happeing-inarni-home-page/whats-happening4.webp'
        },
    ];
    mediaImages = [
        {
            src: 'assets/img/media-coverage/arni-cpr-technique.webp',
            date: new Date('2025-03-11'),
            url: 'https://www.divyahimachal.com/2025/03/cpr-technique-explained-to-students-in-arni/',
            text: 'अरनी में छात्रों को समझाई सीपीआर की तकनीक'
        },
        {
            src: 'assets/img/media-coverage/archery-tournament.webp',
            date: new Date('2025-03-01'),
            url: 'https://www.divyahimachal.com/2025/03/national-ranking-archery-tournament-from-16th-at-arni-university/',
            text: 'अरनी यूनिवर्सिटी में नेशनल रैंकिंग आर्चरी टूर्नामेंट 16 से'
        },
        {
            src: 'assets/img/media-coverage/blood-donation.webp',
            date: new Date('2025-02-15'),
            url: 'https://www.divyahimachal.com/2025/02/blood-donation-in-memory-of-martyrs-at-arni-university/',
            text: 'शहीदों की याद में अरनी यूनिवर्सिटी में रक्तदान'
        },
        {
            src: 'assets/img/media-coverage/divya-himachal.webp',
            date: new Date('2024-11-16'),
            url: 'https://www.divyahimachal.com/2024/11/students-created-a-stir-with-cultural-presentations-at-arni-university/',
            text: 'अरनी यूनिवर्सिटी में सांस्कृतिक प्रस्तुतियों से छात्रों ने मचाया धमाल'
        },
        {
            src: 'assets/img/media-coverage/ncc.webp',
            date: new Date('2024-10-25'),
            url: 'https://www.divyahimachal.com/2024/09/awards-to-the-winning-participants-at-arni-university/',
            text: 'अरनी यूनिवर्सिटी में विजेता प्रतिभागियों को पुरस्कार'
        },
        {
            src: 'assets/img/media-coverage/prize-distribution.webp',
            date: new Date('2024-09-15'),
            url: 'https://www.divyahimachal.com/2024/09/awards-to-the-winning-participants-at-arni-university/',
            text: 'अरनी यूनिवर्सिटी में विजेता प्रतिभागियों को पुरस्कार'
        },
        {
            src: 'assets/img/media-coverage/saheedo-ko-salam.webp',
            date: new Date('2024-08-17'),
            url: 'https://www.divyahimachal.com/2024/08/independence-day-celebrations-at-arni-university-salute-to-the-martyrs/',
            text: 'अरनी यूनिवर्सिटी में आजादी का जश्र… शहीदों को सलाम'
        },
        {
            src: 'assets/img/media-coverage/babbu-maan-in-arni.webp',
            date: new Date('2024-03-08'),
            url: 'https://www.divyahimachal.com/2024/03/hp-news-babbu-maan-reached-arni-university-won-everyones-heart-by-giving-an-excellent-presentation/',
            text: 'अरनी विश्वविद्यालय पहुंचे बब्बू मान, बेहतरीन प्रस्तुति देकर जीता सबका दिल'
        }
    ];

    constructor(private route: ActivatedRoute,
                private router: Router,
                private sanitizer: DomSanitizer) {
        this.router.events.subscribe(() => {
            this.currentRoute = this.router.url;
        });
        this.route.data.subscribe(data => {
            this.pageTitle = data.title;

        });
    }

    openPdfModal(event: Event, url: string) {
        event.preventDefault();
        if (url.startsWith('http') && !url.includes(window.location.hostname)) {
            window.open(url, '_blank');
            return;
        }

        this.pdfUrl = url;
        this.sanitizedPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }

    closePdfModal(): void {
        this.pdfUrl = null;
        this.sanitizedPdfUrl = null;
    }

    formatDay(date: string): string {
        // Add your logic to format the day from the date
        return new Date(date).getDate().toString();
    }

    formatMonth(date: string): string {
        // Add your logic to format the month from the date
        return new Date(date).toLocaleString('default', {month: 'short'});
    }


    /*   openPdfModal(event: Event, url: string): void {
           event.preventDefault(); // Prevent default anchor behavior
           this.pdfUrl = url; // Set the URL of the PDF
           this.sanitizedPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url); // Sanitize the URL
       }

       closePdfModal(): void {
           this.pdfUrl = null;
           this.sanitizedPdfUrl = null;
       }*/

    /*openPdfModal(event: Event, url: string): void {
        event.preventDefault(); // Prevent actual link behavior
        this.pdfUrl = url;
    }

    closePdfModal(): void {
        this.pdfUrl = null;
    }

    formatDay(date: any): string {
        const d = new Date(date);
        return d.getDate().toString().padStart(2, '0');
    }

    formatMonth(date: any): string {
        const d = new Date(date);
        return d.toLocaleString('default', { month: 'short' });
    }*/

    /* sanitizeDescription(html: string): string {
         // Replace all anchor tags with event bindings
         const div = document.createElement('div');
         div.innerHTML = html;
         const links = div.querySelectorAll('a[data-url]');
         links.forEach(link => {
             const url = link.getAttribute('data-url');
             link.addEventListener('click', (e) => {
                 e.preventDefault();
                 this.openPdfModal(url || '');
             });
         });
         return div.innerHTML;
     }*/

    /* openPdfModal(url: string): void {
         this.pdfUrl = url;
         this.sanitizedPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
         this.showPdfModal = true;
     }

     closePdfModal(): void {
         this.showPdfModal = false;
         this.pdfUrl = null;
         this.sanitizedPdfUrl = null;
     }*/

    openOverlay(image: { src: string; date: Date }) {
        this.selectedImage = image;
    }

    closeOverlay() {
        this.selectedImage = null;
    }

    toggleAccordion(index: number): void {
        this.openedIndex = this.openedIndex === index ? null : index;
    }

    openModal(event: any) {
        this.selectedEvent = event;
    }

    closeModal() {
        this.selectedEvent = null;
    }

    ngOnInit(): void {
    }

    goTo(url: string) {
        this.router.navigateByUrl(url);
    }

}
